import * as Types from "./types";
import _ from "lodash";

const initialState = {
  busData: [],
  schedules: [],
  locations: [],
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    case Types.UPDATE_BUS_LOCATION:
      let busData: any[] = _.cloneDeep(state.busData);
      const { data } = action.payload;

      const indexToUpdate = _.findIndex(busData, (o: any) => {
        return o.vehicle.id === data.vehicle.id;
      });

      if (indexToUpdate !== -1) {
        busData[indexToUpdate] = data;
      } else {
        busData = [...busData, data];
      }
      return {
        ...state,
        busData,
      };

    case Types.GET_BUS_ETA_SUCCESS:
      return {
        ...state,
        busData: action.payload.data,
      };
    case Types.UPDATE_LOCATION_LIST:
      return {
        ...state,
        locations: action.payload.data,
      };
    default:
      return state;
  }
};
